<template>
  <div class="colonne-size">
    <b-button-group>
      <b-button
        v-for="el in colClasses"
        :key="`size-${el.value}`"
        :pressed="activeCol===el.display"
        @click="resizeColonne(el.value)"
      >{{el.display}}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  props: {
    activeCol: String,
    colClasses: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    resizeColonne (size) {
      this.$emit('resizeCol', size)
    }
  }
}
</script>

<style lang="scss">
  .colonne-size{
    position: absolute;
    left: 0;
    top:-35px;
    height: 35px;
    button{
      background-color: #FFF;
      border: 1px solid rgba(0, 0, 0, 0.1);
      color: #000;
      border-radius: 0;
      font-weight: normal;
      &:hover{
        color: #FFF;
        border-color: #10608F;
        background-color: #10608F;
      }
      &.active{
        color: #FFF !important;
        border-color: rgba(0, 0, 0, 0.1) !important;
        background-color: #10608F !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/colonneSize.vue